export default "__VITE_ASSET__0Mo5dek$__"